<template>
  <div class="card-container">
    <div
      class="credit-card"
      :class="[
        { 'is-flipped': isFlipped },
        creditCard.flag ? `card__${creditCard.flag}` : null,
      ]"
    >
      <div class="card__face card__face--front">
        <span class="card__item card__item--title">Cartão de crédito</span>
        <span class="card__item card__item--number">{{ creditCard.numberFormated || '•••• •••• •••• ••••' }}</span>

        <span v-if="!creditCard.name" class="card__item card__item--name">{{ $t(`${namespace}.namePrintedOnCard`) }}</span>
        <span v-else class="card__item card__item--name text-uppercase">{{ creditCard.name }}</span>

        <span class="card__item card__item--validate">{{ creditCard.validateFormated || $t(`${namespace}.datePattern`) }}</span>
        <span v-if="!isFlipped" class="card__flag"></span>
      </div>

      <div class="card__face card__face--back">
        <span class="card__stripe"></span>
        <span class="card__cvv">{{ creditCard.cvv || '•••' }}</span>
        <span v-if="isFlipped" class="card__flag"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreditCard',
  props: {
    isFlipped: {
      type: Boolean,
      default: false
    },
    creditCard: {
      type: Object,
      default: () => ({
        number: null,
        numberFormated: null,
        name: null,
        validate: null,
        cvv: null,
        flag: null
      })
    }
  },
  data () {
    return {
      namespace: 'Components.CreditCard'
    }
  }
}
</script>

<style lang="scss" scoped>
$padding-a: 24px;

.is-flipped {
  transform: translateX(-100%) rotateY(-180deg);
}

.card-container {
  height: 190px;
  margin: 0 auto 15px;
  perspective: 600px;
  width: 325px;

  .credit-card {
    height: 100%;
    position: relative;
    transform-style: preserve-3d;
    transform-origin: center right;
    transition: transform .5s;
    width: 100%;
  }

  .card__face {
    backface-visibility: hidden;
    border-radius: 9px;
    height: 100%;
    padding: $padding-a;
    position: absolute;
    width: 100%;
  }

  .card__face--front {
    background-color: #ddd;
    background-image: url('~@/assets/img/credit-card-yellow.svg');
  }

  .card__face--back {
    background-image: linear-gradient(300deg, $primary, $accent-2);
    transform: rotateY(180deg);
  }
}

.card__flag {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  bottom: 15px;
  height: 40px;
  position: absolute;
  right: 15px;
  width: 60px;
}

.card__amex {

  .card__flag {
    background-image: url('~@/assets/img/payment-methods/amex.svg');
    background-size: 70%;
  }
}

.card__diners {

  .card__flag {
    background-image: url('~@/assets/img/payment-methods/diners.svg');
  }
}

.card__elo {

  .card__flag {
    background-image: url('~@/assets/img/payment-methods/elo.svg');
  }
}

.card__hipercard {

  .card__flag {
    background-image: url('~@/assets/img/payment-methods/hipercard.svg');
  }
}

.card__mastercard {

  .card__flag {
    background-image: url('~@/assets/img/payment-methods/master-card.svg');
  }
}

.card__visa {

  .card__flag {
    background-image: url('~@/assets/img/payment-methods/visa.svg');
  }
}

.card__item {
  display: block;
  font-weight: 600;
}

.card__item--title {
  margin-bottom: 39px;
}

.card__item--number {
  font-size: 19px;
  margin-bottom: 8px;
}

.card__item--name {
  margin-bottom: 8px;
}

.card__stripe {
  background-image: linear-gradient(98deg, $gray-7, $gray-8);
  display: block;
  height: 48px;
  left: 0;
  position: absolute;
  right: 0;
  top: 17px;
}
.card__cvv {
  background-color: $white;
  font-size: 19px;
  font-weight: 600;
  height: 32px;
  left: 16px;
  line-height: 32px;
  padding: 0 8px;
  position: absolute;
  top: 73px;
  text-align: right;
  width: 207px;
}

.card__face--back {

  .card__flag {
    position: absolute;
    left: 15px;
    right: auto;
  }
}
</style>
